import React, { useState } from "react";
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// ModalMessgeFileSize: Componente que renderiza un mensaje cuando el archivo multimedia
// subido supera el tamaño máximo.

const ModalMessageFileSize = ({ openMessageFileSize, setOpenMessageFileSize }) => {
    
      const [open, setOpen] = useState(true);

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenMessageFileSize(false);
      };
    
      const action = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );
    
      return (
        <div>
          <Snackbar
            open={openMessageFileSize}
            autoHideDuration={2000}
            onClose={handleClose}
            message="Tamaño del archivo superior a 10MB"
            action={action}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          />
        </div>
      );
    
    
};

export default ModalMessageFileSize;